import { versionedHttpCollection } from "us.helper/http/collection";

export default {
  systemCredentials: {
    get: (): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "credentialservice",
            `systemcredentials`,
            {},
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
